import {
  GET_ALL_CHATS,
} from './Constants';

const initialState = {
  isLoading: true,
  chatList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CHATS:
      return {
        ...state,
        chatList: action.data,
        isLoading: false,
      };
    default:
      return state;
  }
}